import React from 'react';
import T from 'prop-types';

import { format } from '../../../../utils/date';

const Xray = ({ tags, store }) => (
  <div className="insights-details-block__content-table insights-details-block__content-table-tags">
    <div className="insights-details-block__content-table-head">
      <div className="insights-details-block__content-table-head-item">
        Feature
      </div>
      <div className="insights-details-block__content-table-head-item">
        Date Added
      </div>
    </div>
    <div className="insights-details-block__content-table-body">
      {tags.map(tag => (
        <div key={tag.name} className="insights-details-block__content-table-body-item">
          <div className="insights-details-block__content-table-body-item-name">
            <a
              className="d-inline-block link-md text-truncate"
              target="_blank"
              rel="noreferrer"
              href={`/x-ray/tag_comparison?tag_id=${tag.tag}&store=${store}`}
            >
              {tag.name}
            </a>
          </div>
          <div className="insights-details-block__content-table-body-item-date">
            {format(tag.date, 'MMMM DD, YYYY')}
          </div>
        </div>
      ))}
    </div>
  </div>
);

Xray.propTypes = {
  tags: T.array,
  store: T.string,
};

export default Xray;
